var colors = [
    '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'
  ];

const spendingsData = {  
    type: "bar", 
    series: [{
      data: [10000, 34000, 18000, 28000, 50000, 43000, 60000]
    }],
    options: {
      chart: {
        height: 250,
        type: "bar",
        events: {
          click: function(chart, w, e) {
          }
        }
      },
      colors: colors,
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: true,
        position: 'right'
      },
      xaxis: {
        categories: [
          ["Kigumo Subcounty"],
          ["Gatanga Subcounty"],
          ["Kandara Subcounty"],
          ["Kangema Subcounty"],
          ["Kiharu Subcounty"],
          ["Mathioya Subcounty"],
          ["Maragwa Subcounty"]
        ],
        labels: {
          style: {
            colors: colors,
            fontSize: '12px'
          }
        }
      }
    },
}
export default spendingsData;
  